import React, { Component } from "react"
import { Input } from "reactstrap"
/**
 * The projects selector is used at the top level to allow the projects that are being viewed to be grouped by selecting and deselecting the ones to show.
 */
export default class PortfolioSelector extends Component {
  render() {
    const isRestrictedToOne =
      this.props.restrictions.restrictProjects === "yes" ||
      (this.props.portfolios &&
        this.props.portfolios.length === 1 &&
        this.props.restrictions.restrictProjects === "portfolios")
    const hasLimitedPortfolios = !this.props.portfolios || this.props.portfolios.length <= 1

    // If restricted or has 1 or no portfolios, render a static display
    if (isRestrictedToOne || hasLimitedPortfolios) {
      let displayText = "All Projects"

      if (this.props.portfolios && this.props.portfolios.length === 1) {
        displayText = this.props.portfolios[0].name
      } else if (!this.props.portfolios || this.props.portfolios.length === 0) {
        displayText = "No Portfolios"
      } else if (this.props.portfolio) {
        displayText = this.props.portfolio.name
      }

      return <div className="form-control portfolio-selector-static">{displayText}</div>
    }

    // Otherwise render the normal dropdown
    return (
      <Input
        type="select"
        value={this.props.portfolio ? this.props.portfolio.id : ""}
        onChange={(e) => {
          this.props.actions.selectPortfolio(e.target.value)
        }}
      >
        <option value="">All Projects</option>
        {this.props.portfolios
          ? [...this.props.portfolios]
              .sort((a, b) => {
                if (a.name < b.name) return -1
                if (a.name > b.name) return 1
                return 0
              })
              .map((portfolio) => {
                return (
                  <option key={portfolio.id} value={portfolio.id}>
                    {portfolio.name}
                  </option>
                )
              })
          : null}
      </Input>
    )
  }
}
